export const signOut = () => {
    return (dispatch, getState, getFirebase) => {

        const firebase = getFirebase();
        const auth = firebase.auth();
        auth.signOut() 
            .then(() => {

            })
            .catch((e) => {

            })
    }
}

export const withdrawal = (password, funcs) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const auth = firebase.auth();
        const { user } = getState();

        const credentials = firebase.auth.EmailAuthProvider.credential(user.email, password);
        auth.currentUser.reauthenticateAndRetrieveDataWithCredential(credentials)
            .then(() => {
                auth.currentUser.delete()
                    .then(() => {
                        const accountRef = firebase.ref().child(`accounts/${user.uid}`);
                        accountRef.remove()
                            .then(() => {
                                if (funcs && funcs.successFunc) funcs.successFunc();
                            })
                            .catch((e) => {
                                if (funcs && funcs.failedFunc) funcs.failedFunc(e);
                            })
                    })
                    .catch((e) => {
                        if(funcs && funcs.failedFunc) funcs.failedFunc(e);
                    })
            })
            .catch((e) => {
                if (funcs && funcs.failedFunc) funcs.failedFunc(e);
            })
    }
}

export const updateUserInfo = (datas, passwords, funcs) => {
    return (dispatch, getState, getFirebase) => {

        const firebase = getFirebase();
        const {user} = getState();
        const auth = firebase.auth();

        const userRef = firebase.ref().child(`accounts/${user.uid}`)

        const shouldUpdatePassword = passwords.newPassword !== null && passwords.newPassword !== '';
        const shouldUpdateAddress = datas.address !== null && datas.address !== '';
        const shouldUpdatePhone = datas.phone !== null && datas.phone !== '';

        const credentials = firebase.auth.EmailAuthProvider.credential(user.email, passwords.currentPassword);
        auth.currentUser.reauthenticateAndRetrieveDataWithCredential(credentials)
            .then(() =>{
                if(shouldUpdateAddress || shouldUpdatePhone) {
                    userRef.update(datas)
                        .then(() => {
                            console.log('updateSuccess');
                            if(shouldUpdatePassword) {
                                auth.currentUser.updatePassword(passwords.newPassword)
                                    .then(() => {
                                        if (funcs && funcs.successFunc) funcs.successFunc();
                                    })
                                    .catch((e) => {
                                        console.log('update password failed');
                                        if (funcs && funcs.failedFunc) funcs.failedFunc(e);
                                    })
                            }
                            else {
                                if (funcs && funcs.successFunc) funcs.successFunc();
                            }
                        })
                        .catch((e) => {
                            if (funcs && funcs.successFunc) funcs.failedFunc(e);
                        })
                }
            })
            .catch((e) => {
                if (funcs && funcs.failedFunc) funcs.failedFunc(e);
            })
    }
}

export const saveNewInfo = (info) => {
    return { type : 'SAVE_NEW_INFO', payload : { info } }
}
export const resetInfo = () => {
    return { type : 'RESET_INFO'}
}

export const sendVerificationEmail = (funcs) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const auth = firebase.auth();

        auth.currentUser.sendEmailVerification()
            .then(() => {
                if(funcs && funcs.successFunc)
                    funcs.successFunc();
            })
            .catch((e) => {
                if(funcs && funcs.failFunc)
                    funcs.failFunc();
            }) 
    }
}




// WEBPACK FOOTER //
// ./src/pages/MyPage/actions/mypageActions.js